import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { repositoriesKeys } from './repositoriesKeys';

type TParams = QueryFunctionContext<ReturnType<typeof repositoriesKeys.allByOrg>>;

export const createFetchAllOrganizationRepositoriesQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() => cancelOnSignal(OrganizationsService.getOrgReposList({ oid: organizationId }), signal));
